var _require = require('../../constants/image'),
    TRANSFORM_TYPE_FIT = _require.TRANSFORM_TYPE_FIT;

var _require2 = require('lodash'),
    min = _require2.min;

var blurParam = function blurParam(blur) {
  return blur > 0 ? "blur_" + blur + "%2C" : '';
};

var getImageFilename = function getImageFilename(pathname) {
  return pathname ? pathname.replace(/^media\//, '') : '';
};

var IMAGE_TYPE_PNG = 'png';
var IMAGE_TYPE_GIF = 'gif';
var IMAGE_TYPE_JPG = 'jpg';
var IMAGE_TYPE_JPEG = 'jpeg';
var IMAGE_TYPES = [IMAGE_TYPE_PNG, IMAGE_TYPE_GIF, IMAGE_TYPE_JPG, IMAGE_TYPE_JPEG];

function getFileFormat(fileName) {
  var splitURI = /[.]([^.]+)$/.exec(fileName);
  return (splitURI && /[.]([^.]+)$/.exec(fileName)[1] || '').toLowerCase();
}

function getImageUrl(imageHost) {
  return function produceImage(_temp, _temp2) {
    var _ref = _temp === void 0 ? {} : _temp,
        fileName = _ref.file_name,
        actualWidth = _ref.width,
        actualHeight = _ref.height;

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$maxWidth = _ref2.maxWidth,
        maxWidth = _ref2$maxWidth === void 0 ? 1000 : _ref2$maxWidth,
        _ref2$maxHeight = _ref2.maxHeight,
        maxHeight = _ref2$maxHeight === void 0 ? 1000 : _ref2$maxHeight,
        _ref2$quality = _ref2.quality,
        quality = _ref2$quality === void 0 ? 80 : _ref2$quality,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? TRANSFORM_TYPE_FIT : _ref2$type,
        format = _ref2.format,
        _ref2$blur = _ref2.blur,
        blur = _ref2$blur === void 0 ? 0 : _ref2$blur,
        _ref2$encode = _ref2.encode,
        encode = _ref2$encode === void 0 ? false : _ref2$encode;

    if (!format) {
      var formatFromName = getFileFormat(fileName);
      format = IMAGE_TYPES.includes(formatFromName) ? formatFromName : IMAGE_TYPE_PNG;
    }

    if (fileName) {
      var _ref3 = [min([maxWidth, actualWidth]), min([maxHeight, actualHeight])],
          width = _ref3[0],
          height = _ref3[1];
      return "https://" + imageHost + "/media/" + fileName + "/v1/" + type + "/w_" + width + "%2Ch_" + height + "%2C" + blurParam(blur) + "al_c" + (quality && format !== IMAGE_TYPE_PNG ? "%2Cq_" + quality : '') + (encode ? ',enc_auto' : '') + "/file." + format;
    }

    return '';
  };
}

module.exports = {
  getImageFilename: getImageFilename,
  getImageUrl: getImageUrl,
  getFileFormat: getFileFormat
};